import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from '../../../../../../environments/environment';
import { WEBSITE_URL } from '../../../../../auth/config/constants';
import { AuthService } from '../../../../../auth/services/auth.service';
import { StorageService } from '../../../../../core/helpers/storage.service';
import {
  LoggerService,
  LogLevel,
} from '../../../../../core/services/logger.service';
import { GetInTouchComponent } from '../get-in-touch/get-in-touch.component';
import { SupportComponent } from '../support-dialog/support.component';
@Component({
  selector: 'app-getting-started',
  templateUrl: './getting-started.component.html',
  styleUrl: './getting-started.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    // GetInTouchComponent,
  ],
})
export class GettingStartedComponent implements OnInit, OnDestroy {
  panelOpenState = false;
  videoPopup: boolean = false;
  overviewTimer!: ReturnType<typeof setTimeout>;
  overviewPopup: boolean = false;
  viewAllBtn: boolean = false;
  features: { [key: string]: boolean } = {};
  featureIcons = [
    { class: 'icon-1', feature: 'featureCol1', icon: 'desktop_windows' },
    { class: 'icon-2', feature: 'featureCol2', icon: 'keyboard_voice' },
    { class: 'icon-3', feature: 'featureCol3', icon: 'mail' },
    { class: 'icon-4', feature: 'featureCol4', icon: 'chat_bubble_outline' },
    {
      class: 'icon-5',
      feature: 'featureCol5',
      icon: 'integration_instructions',
    },
    { class: 'icon-6', feature: 'featureCol6', icon: 'confirmation_number' },
    { class: 'icon-7', feature: 'featureCol7', icon: 'settings' },
    { class: 'icon-8', feature: 'featureCol8', icon: 'assessment' },
    { class: 'icon-9', feature: 'featureCol9', icon: 'shield' },
    { class: 'icon-10', feature: 'featureCol10', icon: 'forum' },
    { class: 'icon-11', feature: 'featureCol11', icon: 'attach_money' },
  ];
  featureList = [
    {
      key: 'featureCol1',
      className: 'feature-col feature-1',
      id: '01',
      label: 'Agent Workspace new',
      cont: 'Maximize agent productivity with a unified digital workspace consolidating all customer touchpoints, reducing response times by up to 40% and increasing first-call resolution rates.',
    },
    {
      key: 'featureCol2',
      className: 'feature-col feature-2',
      id: '02',
      label: 'Voice',
      cont: 'Enable seamless business continuity with full-featured capability, ensuring 24/7 operational readiness  for improved customer service',
    },
    {
      key: 'featureCol3',
      className: 'feature-col feature-3',
      id: '03',
      label: 'Email',
      cont: 'Turn emails into smart, trackable conversation.  Deliver consistent, personalized support',
    },
    {
      key: 'featureCol4',
      className: 'feature-col feature-4',
      id: '04',
      label: 'Chat',
      cont: 'Meet your customers where they are. Instant conversations, lasting impressions. Seamless chat. Smarter service-One platform.',
    },
    {
      key: 'featureCol5',
      className: 'feature-col feature-5',
      id: '05',
      label: '3rd Party Integration',
      cont: 'Easily connect with the tools you already use. Open APIs, plug-and-play connectors, and full ecosystem support our CCaaS fits into your world, not the other way around.',
    },
    {
      key: 'featureCol6',
      className: 'feature-col feature-6',
      id: '06',
      label: 'Ticketing System',
      cont: 'Never lose track of a customer issue again built-in ticketing  and  Case Management keeps every conversation accounted for.',
    },
    {
      key: 'featureCol7',
      className: 'feature-col feature-7',
      id: '07',
      label: 'Workflow and Triggers',
      cont: 'Automate the routine, with built-in workflows &  triggers. Work smarter, not harder customizable workflows that adapt to your business rules in real time.',
    },
    {
      key: 'featureCol8',
      className: 'feature-col feature-8',
      id: '08',
      label: 'Analytics and Dashboarding',
      cont: 'Make smarter decisions, faster.Turn every interaction into insight—real-time analytics and dashboards built for action.',
    },
    {
      key: 'featureCol9',
      className: 'feature-col feature-9',
      id: '09',
      label: 'Administration',
      cont: 'Get up and running in hours, not days intuitive setup that anyone can manage. No heavy lifting streamlined administration designed for real people, not just IT.',
    },
    {
      key: 'featureCol10',
      className: 'feature-col feature-10',
      id: '10',
      label: 'AI Translation',
      cont: 'Our advanced AI technology solution offers real-time translation and transcription across 140+ languages, supplemented by sentiment analysis, conversation summaries.',
    },
    {
      key: 'featureCol11',
      className: 'feature-col feature-11',
      id: '11',
      label: 'Sales and Marketing',
      cont: 'Turn every interaction into a lead—built-in tools to capture, qualify, and convert. From first touch to closed deal—seamless lead and opportunity management inside your CCaaS.',
    },
  ];
  lastSession: string = '';
  env = environment.ENV;
  readonly dialog = inject(MatDialog);
  constructor(
    private readonly router: Router,
    private readonly storageService: StorageService,
    private readonly logger: LoggerService,
    private readonly authService: AuthService
  ) {
    for (let i = 1; i <= 11; i++) {
      this.features[`featureCol${i}`] = false;
    }
  }
  ngOnInit(): void {
    this.setOverviewTimer();
  }
  setOverviewTimer(): void {
    this.overviewTimer = setTimeout(() => (this.overviewPopup = true), 3000);
    // document.body.classList.add('hide-scroll');
  }
  closeOverviewPopup() {
    this.overviewPopup = false;
    // document.body.classList.remove('hide-scroll');
  }
  // convertToLocalTime(lastSession: string) {
  //   const utcMoment = moment.utc(lastSession, 'YYYY-MM-DD hh:mm A');
  //   const localMoment = utcMoment.local();
  //   this.lastSession = localMoment.format('MM-DD-YYYY hh:mm A');
  // }
  // setPreferance() {
  //   this.authService.setPreferance('Tenant')?.subscribe({
  //     next: res => {
  //       this.logger.log(LogLevel.INFO, res);
  //     },
  //     error: err => {
  //       this.logger.log(LogLevel.ERROR, err);
  //     },
  //   });
  // }
  openSupportDailog() {
    const dialogRef = this.dialog.open(SupportComponent, {
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe({
      next: response => {
        this.logger.log(LogLevel.INFO, response);
      },
      error: error => {
        this.logger.log(LogLevel.ERROR, error);
      },
    });
  }

  goToLogin() {
    this.router.navigate(['auth/login']);
  }

  signOut() {
    this.authService.logoutEvent.emit(
      'User triggered Logout from Tenant Getting Started Page'
    );
  }
  toggleVideoPopup() {
    this.videoPopup = !this.videoPopup;
  }
  toggleFeature(name: string) {
    this.features[name] = true;
  }
  viewAllFeatures(): void {
    Object.keys(this.features).forEach(key => (this.features[key] = true));
    this.viewAllBtn = true;
  }
  gotoPrivacy() {
    window.open(WEBSITE_URL.WEBSITE_PRIVACY, '_blank');
  }
  gotoTerms() {
    window.open(WEBSITE_URL.WEBSITE_TERMS, '_blank');
  }
  goToHelpTopics(index: number) {
    this.router.navigate(['help-topics'], {
      queryParams: {
        tab: index,
      },
    });
  }
  ngOnDestroy(): void {
    if (this.overviewTimer) {
      clearTimeout(this.overviewTimer);
    }
    this.dialog?.closeAll();
  }
}
export { GetInTouchComponent };
